import { useProductListing } from 'contexts/productListingContext';
import { usePathname, useSearchParams } from 'next/navigation';

export default function useAnalyticsListId(listId?: string, page?: string) {
  const productListContext = useProductListing();
  const searchParams = useSearchParams();
  const pathname = usePathname();

  const originsPLA = ['pla', 'criteo', 'rtbhouse', 'dra', 'facebookdpa'];
  const paramOriginValue = searchParams?.get('origem');
  const hasOriginPLA = originsPLA.some(option => paramOriginValue?.includes(option));
  const slugValue = searchParams?.get('slug')?.[0];

  const parseListName = (parentList: string) => {
    if (productListContext?.currentListNameId) {
      const sublistName = `- ${productListContext.currentListNameId}`;
      return hasOriginPLA ? `PLA ${sublistName}` : `${parentList} ${sublistName}`;
    }

    return parentList;
  };

  if (pathname?.includes('/busca/')) {
    return parseListName('Busca SEO');
  }

  if (searchParams?.get('q')) {
    return parseListName('Busca');
  }

  if (page === 'daily-sales') {
    return 'Banner - Ofertas do dia';
  }

  if (pathname?.includes('landing') && listId !== 'PLA') {
    return slugValue!;
  }

  if (pathname?.includes('lojista')) {
    return listId ? `Seller - ${listId}` : `Seller - ${slugValue}`;
  }

  if (pathname?.includes('hotsite') && listId !== 'PLA') {
    return listId ? `Banner - ${listId}` : `Banner - ${slugValue}`;
  }

  if (pathname?.includes('wishlist')) {
    return 'Lista Favoritos - meus favoritos';
  }

  if (pathname === '/') {
    return listId ?? searchParams?.toString() ?? '/';
  }

  if (page?.includes('category')) {
    return parseListName(`Navegação`);
  }

  if (page?.includes('department')) {
    return parseListName(`Departamento - ${listId}`);
  }

  if (pathname === '/carrinho' && !listId?.startsWith('Cart')) {
    return parseListName(`Cart - ${listId}`);
  }

  return parseListName(slugValue ?? listId!);
}
